import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from './api.ts'
import type { Job, JobFlag, JobsDetail } from './types.ts'

// A company's jobs, review list and sources. Loaded once per visit (a load by Icefield
// support is logged), and replaced by what each action answers with.

export const jobsKey = (companyId: string) => ['jobs', companyId] as const

export function useJobs(companyId: string) {
  return useQuery({
    queryKey: jobsKey(companyId),
    queryFn: () => api.get<JobsDetail>(`/companies/${companyId}/jobs`),
    staleTime: Infinity,
  })
}

/** Run an action that answers with the jobs data, and show that. */
export function useJobsAction(companyId: string) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (run: () => Promise<JobsDetail>) => run(),
    onSuccess: (detail) => queryClient.setQueryData(jobsKey(companyId), detail),
  })
}

export const ALERT_KINDS: JobFlag['kind'][] = ['rejected_rows', 'malformed_report', 'stale_source']

export const jobLabel = (job: Job | undefined) => (job ? `#${job.number} ${job.name}` : 'a job no longer listed')

export const SOURCE_TYPES: Record<string, string> = {
  dash_email: 'DASH (emailed report)',
  smartsheet: 'Smartsheet',
  upload: 'Uploaded by hand',
}
